<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" class="pa-4 pt-8">
        <h3 class="pa-0">Angebote</h3>
      </v-col>
      <v-col cols="12">
        <HeadlineItem
          :url="item.url"
          :title="item.title"
          :subtitle="item.subtitle"
          :message="item.text"
          :src="item.image"
          @click="clickProduct(item)"
          :item="item"
          v-for="(item, index) in products_top"
          :key="index"
        ></HeadlineItem>
      </v-col>

      <!-- Eyecatcher -->
      <v-col cols="12" class="pb-5">
        <EyecatcherRegion></EyecatcherRegion>
      </v-col>

            <v-col cols="12">
        <HeadlineItem
          :url="item.url"
          :title="item.title"
          :subtitle="item.subtitle"
          :message="item.text"
          :src="item.image"
          @click="clickProduct(item)"
          :item="item"
          v-for="(item, index) in products_bottom"
          :key="index"
        ></HeadlineItem>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { firebase } from "../main";
import HeadlineItem from "../components/design/HeadlineItem";
import NewsItem from "../components/design/NewsItem";

import EyecatcherRegion from "../components/regions/EyecatcherRegion";

export default {
  data() {
    return {
      products: [],
    };
  },
  firestore() {
    return {
      products: firebase
        .firestore()
        .collection("products")
        .where("eyecatcher", "==", "0")
        .orderBy("sortorder", "desc"),
    };
  },
  computed: {
    products_top: function () {
      return this.products.slice(0, 2);
    },
    products_bottom: function () {
      return this.products.slice(2);
    },
  },
  methods: {
    clickProduct(item) {
      if (item.hasOwnProperty("url")) {
        window.open(item.url, "_blank");
      }
    },
  },
  components: {
    HeadlineItem,
    NewsItem,
    EyecatcherRegion,
  },
};
</script>